import UserService from "@/services/user";

export const state = {
    type: null,
    message: null,
    notifications: [],
    notificationsCount: 0,
};

export const mutations = {
    success(state, message) {
        state.type = 'alert-success';
        state.message = message;
    },
    error(state, message) {
        state.type = 'alert-danger';
        state.message = message;
    },
    clear(state) {
        state.type = null;
        state.message = null;
    },
    ADD_NOTIFICATION(state, notification) {
      state.notifications.push(notification);
      state.notificationsCount = state.notifications.length || 0;
    },
    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications;
      state.notificationsCount = notifications.length || 0;
    },
    CLEAR_NOTIFICATIONS(state) {
      state.notifications = [];
      state.notificationsCount = state.notifications.length || 0;
    },
};

export const actions = {
    success({ commit }, message) {
        commit('success', message);
    },
    error({ commit }, message) {
        commit('error', message);
    },
    clear({ commit }) {
        commit('clear');
    },
    addNotification({ commit }, notification) {
      commit('ADD_NOTIFICATION', notification);
    },
    setNotifications({ commit }, notifications) {
      commit('SET_NOTIFICATIONS', notifications);
    },
    clearNotifications({ commit }) {
      commit('CLEAR_NOTIFICATIONS');
    },
    fetchNotifications({ commit }) {
      UserService.getNotifications().then(res => {
        commit('SET_NOTIFICATIONS', res.data);
      })
    }
};

export const getters = {
  allNotifications: (state) => state.notifications,
}
